angular.module('tgaAdmin').service('bannerNotificationsService', [
  '$http',
  'envService',
  'domainService',
  'rootScopeCacheService',
  '$timeout',
  '$log',
  '$interval',
  'localStorageService',
  function ($http, envService, domainService, rootScopeCacheService, $timeout, $log, $interval, localStorageService) {
    const serverAddress = envService.read('serverAddress');
    let timer = null;

    function add(data) {
      return $http({
        method: 'POST',
        url: `${serverAddress}banner/add`,
        cancelOnRouteChange: false,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function update(banner_id, data) {
      return $http({
        method: 'PUT',
        url: `${serverAddress}banner/update/${banner_id}`,
        cancelOnRouteChange: false,
        data,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function del(banner_id) {
      return $http({
        method: 'DELETE',
        url: `${serverAddress}banner/delete/${banner_id}`,
        cancelOnRouteChange: false,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function dismiss(banner_id) {
      return $http({
        method: 'POST',
        url: `${serverAddress}banner/dismiss`,
        cancelOnRouteChange: false,
        data: {
          banner_id,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function get() {
      return $http({
        method: 'GET',
        url: `${serverAddress}banner`,
        cancelOnRouteChange: false,
        params: {
          domain: domainService.domain,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getOne(banner_id) {
      return $http({
        method: 'GET',
        url: `${serverAddress}banner/one`,
        cancelOnRouteChange: true,
        params: {
          banner_id,
        },
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getAll() {
      return $http({
        method: 'GET',
        url: `${serverAddress}banner/all`,
        cancelOnRouteChange: true,
      }).then(
        (response) => response.data,
        (error) => {
          throw error.data;
        },
      );
    }

    function getBannersAndCache() {
      get().then((banners) => {
        rootScopeCacheService.set('banners', banners);
      });
    }

    // set polling time to 5 mins
    const pollingTime = 300000;
    // make sure it only runs once
    let startedPolling = false;
    function startBannerPolling() {
      if (startedPolling) {
        return;
      }
      startedPolling = true;
      $log.debug('bannerNotificationsService: notification polling started');
      getBannersAndCache();
      timer = $interval(() => getBannersAndCache(), pollingTime);
    }

    function destroy() {
      localStorageService.remove('tempDismissedBanners');
      $interval.cancel(timer);
    }

    return {
      add,
      update,
      del,
      dismiss,
      get,
      getOne,
      getAll,
      getBannersAndCache,
      startBannerPolling,
      destroy,
    };
  },
]);
